import React, { useState, useEffect, useContext } from 'react'
import { useAuth } from '@polvo-labs/react-auth'
import io from 'socket.io-client'
import { Message } from './components/Chat/type'
import env from './config/env'

type Type = SocketIOClient.Socket | undefined

export interface StatusChange {
  user: string
  status: boolean
}
export interface MessageReceived {
  room: string
  payload: Message
}


const SocketContext = React.createContext<Type>(undefined)

const SocketProvider: React.FC = ({ children }) => {
  const [socket, setSocket] = useState()
  const { token } = useAuth()

  useEffect(() => {
    const socket = io(env.chatURL, {
      transportOptions: {
        polling: {
          extraHeaders: {
            Authorization: `Bearer ${token}`,
          },
        },
      },
    })

    setSocket(socket)
  }, [token])

  if (!socket) {
    return null
  }

  return (
    <SocketContext.Provider
      value={socket}
    >
      {children}
    </SocketContext.Provider>
  )
}

const useSocket = () => useContext(SocketContext)

export {
  SocketProvider,
  useSocket,
}
export default SocketContext
